// extracted by mini-css-extract-plugin
export default {"wrapper":"zT-z","availablePromoMessagesLabel":"AT-z","promoMessageList":"BT-z","promoMessage":"CT-z","appliedPromoMessage":"DT-z","promoMessageAmount":"ET-z"};